import { Component, h } from 'preact';
import CSSModules from 'react-css-modules';
import ClassNames from 'classnames';
import styles from '../../css/app.css';
import TweenLite from 'gsap/TweenLite';
import { Container, ticker, Sprite, Texture, Graphics, Text } from 'pixi.js';
import 'gsap/PixiPlugin';
import ReactMarkdown from 'react-markdown';

import { GetSimpleRect } from '../../utils-and-data/utils.js';
import events from '../../utils-and-data/events.js';
import FxLayer from '../partials/fx-layer.js';
import BackgroundGhost from '../animations/background';
import SmokeImg from '../../img/smoke-blurred.png';

// @TODO: move these into config, maybe?
const eventOptions = {
  passive: false,
  capture: true
};

class Smoke extends Component {
  constructor(props) {
    console.log('Ghost Smoke starting here')
    console.log('-----------------------')
    super(props);
    this.state = { }
    this.initialised = false;
    this.destroyTimer = null;
    this.START_GHOST_TOUCH_THRESHOLD = 10;

    // we can either write all the Loader logic, init, load, destroy
    // or preheat the cache once.
    const preheat = new Sprite.fromImage(SmokeImg);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.order !== this.props.order) {
      this.initOrDestroy();
    }
  }

  componentWillUpdate(nextProps, nextState) {

    // Allow the webGL layer to follow the carousel's movement:
    if (nextProps.ghostTransX
      && this.initialised && this.ghosting) {
      this.container.x = nextProps.ghostTransX;
    }

    let oldGhost = this.props.ghost.paragraphs.join('');
    let newGhost = nextProps.ghost.paragraphs.join('');
    if (oldGhost !== newGhost) this.genGhostText();
  }

  componentDidMount() {
    this.initOrDestroy(this.props);
  }

  componentWillUnmount() {
    this.destroyGhost();
  }

  // Generates all the smoke and text content so it's ready for rendering.
  createScene() {
    this.ticker = new ticker.Ticker();
    this.ticker.stop();
    this.ticker.add(this.animateSmoke);
    this.smokeParticles = [];

    this.container = new Container();
    this.smoke1 = new Container();
    this.smoke2 = new Container();
    this.smoke2.alpha = 0;
    this.smoke1.alpha = 0;

    this.bg = new BackgroundGhost(this.props, 'smoke')
    this.container.addChild(this.bg);

    this.smokeContainers = [];
    this.oldTime = Date.now();

    // These two layers behind the text, and smaller with lower opacity.
    // This makes the smoke looke more volumetric.
    this.generateParticles(15, 1, 0.4, this.smoke1);
    this.generateParticles(15, 1.2, 0.6, this.smoke1);

    this.container.addChild(this.smoke1);

    // Make text:
    this.textContainer = new Container();
    this.textContainer.alpha = 0;
    this.container.addChild(this.textContainer);
    this.genGhostText();

    this.container.addChild(this.smoke2);

    // These two are in front of the text, and larger with less opacity.
    this.generateParticles(12, 1.2, 0.7, this.smoke2);
    this.generateParticles(12, 1.5, 1.0, this.smoke2);

    this.oldTime = Date.now();

    // Clip the smoke, so that it only shows inside the main voice layer:
    FxLayer.voiceLayer.width = this.props.dimensions.width;
    FxLayer.voiceLayer.height = this.props.dimensions.height;

    var mask = new Graphics();
    mask.drawRect(0, 0, this.props.dimensions.width, this.props.dimensions.height);
    mask.renderable = true;
    mask.cacheAsBitmap = true;
    this.container.addChild(mask);
    this.container.mask = mask;
  }

  genGhostText() {

    // First, clear old text:
    while (this.textContainer.children[0]) {
      this.textContainer.removeChild(this.textContainer.children[0]);
    }

    // Now make new text:
    let text = this.props.ghost.paragraphs.join(' ');
    let textObj = new Text(text, {
      fill : 0xffffff,
      align : 'center',
      fontFamily: 'Averia Serif Libre',
      fontWeight: 300,
      fontSize: 16,
      lineHeight: 25,
      wordWrap: true,
      wordWrapWidth: this.props.dimensions.width - 100,
    });
    textObj.position.x = (this.props.dimensions.width / 2) - (textObj.width / 2);
    textObj.position.y = (this.props.dimensions.height / 2) - (textObj.height / 2);
    this.textContainer.addChild(textObj);
  }

  // Creates a container with particles and adds it to the smokeContainers array.
  // Order is either "back" or "front" of the text.
  generateParticles(particleCount, scale, alpha, smokeLayer) {
    let container = new Container({
      position: true,
      rotation: true,
      scale: true,
      alpha: true
    });

    // container.width = this.props.dimensions.width;
    // container.height = this.props.dimensions.height;
    // container.pivot.set(0, 0);
    // container.position.set(0, 0);

    for (let p = 0; p < particleCount; p++) {
      let particle = new Sprite.fromImage(SmokeImg);
      particle.scale.set(scale);
      particle.position.set(
        Math.abs(Math.random() * (this.props.dimensions.width * 1)),
        Math.abs(Math.random() * (this.props.dimensions.height * 0.7)),
        //                  leave some empty space at the bottom  ^
      );

      particle.rotation = Math.random() * (Math.PI * 2);
      particle.alpha = alpha;
      // particle.tint = 0xdbb7bc;
      // particle.tint = 0x9f9f9f;
      container.addChild(particle);
      this.smokeParticles.push(particle);
    }

    smokeLayer.addChild(container);
    this.smokeContainers.push(container);
  }

  animateSmoke = () => {
    console.log('Smoke:::: animateSmoke()');
    const CLOUD_ROTATION_SPEED = 0.07;

    let today = new Date();
    let delta = (Date.now() - this.oldTime) / 1000;
    this.oldTime = today.getTime();

    // @TODO would be good to spin both of these at the same time.
    // For some reason, these refuse to spin from their center,
    // and eventually spin off the page
    // for (let i = 0; i < this.smokeContainers.length; i++) {
    //   this.smokeContainers[i].rotation -= (Math.random() * 0.7) * delta * CLOUD_ROTATION_SPEED;
    // }
    for (var i = this.smokeParticles.length - 1; i >= 0; i--) {
      this.smokeParticles[i].rotation -= (Math.random() * 2.5) * delta * CLOUD_ROTATION_SPEED;
    }
  }

  initOrDestroy() {
    if (this.props.order === 'curr'
      && this.initialised === false) {

      this.initialised = true;
      this.startTimer = setTimeout(() => this.initGhost(), 5);
    } else {
      this.destroyGhost()
    }
  }

  initGhost() {
    console.log('Ghost Smoke initGhost()');
    this.captureEvents();
    this.props.resetCarousel();
    this.props.setCarouselLock(true);
    this.hitzoneRect = GetSimpleRect(this.hitzoneRef);
    this.createScene();
  }

  destroyGhost() {
    TweenLite.killTweensOf(this.container);
    TweenLite.killTweensOf(this.textContainer);
    TweenLite.killTweensOf(this.smoke);
    TweenLite.set(this.floTextRef, { clearProps: 'all' });
    clearTimeout(this.startTimer);
    clearTimeout(this.releaseTimer);

    if (this.ticker) this.ticker.stop();
    if (this.bg) this.bg._destroy();
    if (this.container) this.cleanup();
    if (!this.initialised) return;

    this.releaseEvents();
    events.emit('setLighting', { mode: 'light' });
    FxLayer.voiceLayer.clearChildren();
    FxLayer.stop();
    this.ghosting = false;
    this.initialised = false;
  }

  cleanup() {
    // loop through all elements appended to scene and remove them
    while (this.container.children[0]) {
      this.container.removeChild(this.container.children[0]);
    }
    this.container.destroy({ children:true, texture:true, baseTexture:true });
  }

  showGhost() {
    this.props.resetCarousel();
    console.log('Ghost Smoke showGhost()');
    events.emit('setLighting', { mode: 'dark' });
    this.ghosting = true;
    this.initialised = true;
    FxLayer.voiceLayer.addChild(this.container);
    FxLayer.start();

    this.ticker.start();
    TweenLite.to(this.smoke1, 1.5, { alpha: 1 });
    TweenLite.to(this.smoke2, .5, {
      alpha: 1,
      onComplete: () => {
        TweenLite.to(this.floTextRef, .5, {
          opacity: 0,
          onComplete: () => {
            TweenLite.to(this.textContainer, 1.5, {
              alpha: 1,
            })

            this.bg.animatedShow(() => {
              TweenLite.to(this.smoke2, 1, {
                alpha: 0.73,
                delay: 0.5,
                onComplete: () => {
                  this.unlock();
                }
              });
            }, .5)
          }
        })
      }
    });
  }

  unlock() {
    console.log('Ghost Smoke unlock()');
    FxLayer.bounce(() => {
      this.releaseEvents();
      this.props.setCarouselLock(false);
    });
  }

  // define some custom canvas methods:
  captureEvents = () => {
    this.hitzoneRef.addEventListener('mousedown', this.onDrawStart, eventOptions);
    this.hitzoneRef.addEventListener('mouseup', this.onDrawEnd, eventOptions);
    this.hitzoneRef.addEventListener('touchstart', this.onDrawStart, eventOptions);
    this.hitzoneRef.addEventListener('touchend', this.onDrawEnd, eventOptions);
  }

  releaseEvents = () => {
    this.hitzoneRef.removeEventListener('mouseup', this.onDrawEnd, eventOptions);
    this.hitzoneRef.removeEventListener('mousemove', this.onMouseMove, eventOptions);
    this.hitzoneRef.removeEventListener('mousedown', this.onDrawStart, eventOptions);

    this.hitzoneRef.removeEventListener('touchend', this.onDrawEnd, eventOptions);
    this.hitzoneRef.removeEventListener('touchmove', this.onTouchMove, eventOptions);
    this.hitzoneRef.removeEventListener('touchstart', this.onDrawStart, eventOptions);
  }

  stopAndPrevent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  onDrawStart = (e) => {
    console.log('onDrawStart');
    this.oldPos = null;
    this.stopAndPrevent(e);

    this.hitzoneRef.addEventListener('mousemove', this.onMouseMove, eventOptions);
    this.hitzoneRef.addEventListener('touchmove', this.onTouchMove, eventOptions);
  }

  onDrawEnd = (e) => {
    this.stopAndPrevent(e);
    this.hitzoneRef.removeEventListener('mousemove', this.onMouseMove, eventOptions);
    this.hitzoneRef.removeEventListener('touchmove', this.onTouchMove, eventOptions);
  }

  onMouseMove = (e) => {
    this.stopAndPrevent(e);
    let y = e.pageY - this.hitzoneRect.top;
    let x = e.pageX - this.hitzoneRect.left;
    this.onDrawMove(x,y);
  }

  onTouchMove = (e) => {
    this.stopAndPrevent(e);
    let x = e.touches[0].clientX - this.hitzoneRect.left,
      y = e.touches[0].clientY - this.hitzoneRect.top;
    this.onDrawMove(x,y);
  }

  onDrawMove = (x,y) => {
    if (!this.oldPos) this.oldPos = { x: x, y: y };

    // Detect if they've dragged enough from the start point
    // to enable the ghost to start:
    if (!this.ghosting) {
      if (Math.max(
        Math.abs(this.oldPos.x - x),
        Math.abs(this.oldPos.y - y)
      ) >= this.START_GHOST_TOUCH_THRESHOLD) {
        this.showGhost();
      }
    }
  }

  storeRef(type, el) {
    if (el !== null) this[type] = el;
  }

  render() {
    return (
      <div styleName='ghost-panel'
        className={ClassNames('shift-ghost', this.props.order)}
        ref={h => this.storeRef('hitzoneRef', h)}>

        <div className='flo state'>
          <div className='inner' ref={r => this.storeRef('floTextRef', r)}>
            {this.props.paragraphs.map((text,i) => {
              return <ReactMarkdown source={text} />
            })}
          </div>
        </div>
      </div>
    )
  }
}

// Apply 'react-css-modules' to this react component:
export default CSSModules(Smoke, styles);
// export default Smoke;



// WEBPACK FOOTER //
// ./app/frontend/components/panels/ghost-smoke.jsx